import moment from 'moment-timezone';

export default {

	computed: {

		status() {
			if (this.order && this.order.status) {
				return this.order.status.toLowerCase();
			}

			return 'Unknown';
		},

		statusClassColor() {
			switch (this.status.toUpperCase()) {
				case 'SHIPPED':
					return 'good-bg';
				case 'CANCELED':
					return 'bad-bg';
				default:
					return 'neutral-bg';
			}
		},

		date() {
			if (this.order && this.order.created_at ) {
				return moment.tz(this.order.created_at, 'UTC').format('MMM D, YYYY @ hh:mmA');
			}

			return 'Unknown';
		},

		canUpdateOrder() {
			return [ 'shipped', 'canceled' ].indexOf(this.status) === -1;
		},

	},

};
